import { Edit } from "react-admin";
import GroupCertificationEditForm from "./GroupCertificationEditForm";

export default function GroupsCertificationsEdit() {
  return (
    <Edit mutationMode="pessimistic">
      <GroupCertificationEditForm />
    </Edit>
  );
}
